import { createContext } from "react"

export type Flags = {
  solanaTokenSendEnabled?: boolean
  coinbase_one_banner_enabled?: boolean
  chest_reminder_banner_enabled?: boolean
  token_watchlist_enabled?: boolean
  // Whether or not accepting terms of service is required
  acceptTermsEnabled?: boolean
  // Enables USD input mode in swap modules; when true, toggle may render
  usdSwapInputEnabled?: boolean
  // Optional list of disabled tokens (formatted as `${chain}:${contractAddress}`)
  // for which USD input should be disabled even if enabled globally
  usdSwapInputDisabledTokens?: string[]
  // Enables the ability to add multiple traits in collection offer flow
  multiTraitOffersEnabled?: boolean
}

export type FlagContextType = {
  flags: Partial<Flags>
  flagsReady: boolean
}

export const FlagContext = createContext<FlagContextType>({
  flags: {},
  flagsReady: false,
})
